<template>
  <el-dialog width="600px" title="批量修改订单供应商" v-model="isvisible">
    <el-form
      ref="orderFormRef"
      :model="orderForm"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="供应商" prop="supplierid">
        <el-select
        style="width:100%"
        v-model="orderForm.supplierid"
        filterable
        placeholder="选择供应商"
      >
        <template v-for="item in supplierData" :key="item.supplierid">
          <el-option :label="item.name" :value="item.supplierid" />
        </template>
      </el-select>
        
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
        <el-button type="danger" @click="doBatchSaveOrderSupplier" :loading="loading" >{{
          loading ? "提交中 ..." : "确认"
        }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>
  <script setup>
import { ref, defineExpose, defineEmits } from "vue";
import { ElMessage } from "element-plus";
import { batchSaveOrderSupplier } from "@/api/order";

let timer;

const loading = ref(false);

const emit = defineEmits(["click"]); // 声明父触发事件

const isvisible = ref(false);
const changeVisible = (v) => {
  isvisible.value = v;
};

const orderFormRef = ref();
const orderForm = ref({
  orderid: "",
  supplierid: "",
});

const supplierData = ref([])

const orderSupplierMethod = (obj) => {
  orderForm.value = {
    orderid: obj.orderid,
  };
  supplierData.value = obj.suppliers
  // console.log("supplierData.value---", supplierData.value);
  // console.log("orderForm.value---", orderForm.value);

};

defineExpose({ changeVisible, orderSupplierMethod });

const doBatchSaveOrderSupplier = () => {
  orderFormRef.value.validate((valid) => {
    if (!valid) {
      // ElMessage("请先完善表单数据填写！");
      return;
    }

    let orders = [];
    let orderids = orderForm.value.orderid;

    for (let i = 0; i < orderids.length; i++) {
      orders.push({
        orderid: orderids[i],
        supplierid: orderForm.value.supplierid,
      });
    }
    // console.log("orders---", orders);
    // console.log("orderForm.value---", orderForm.value);

    batchSaveOrderSupplier(orders).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          closeDialog();
          emit("click");
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

const closeDialog = () => {
  isvisible.value = false;
  orderFormRef.value.resetFields();
  clearTimeout(timer);
};

//表单验证规则
const rules = ref({
  supplierid: [
    {
      required: true,
      message: "请选择供应商",
      trigger: "change",
    }
  ]
});
</script>
  <style scoped>
.el-dialog {
  text-align: left;
}
.el-dialog__body {
  padding-top: 15px;
}
</style>